<!--To add '&& allPrimaryHub.length>0' condition to '*ngIf'-->
<!--To add '&& allSecondaryHub.length>0' condition to '*ngIf'-->
<div class="right-panel"
     *ngIf="ownerArray.length >0 && allPlatforms.length > 0">
  <div class="panel-header">
    <p class="panel-title">Create a Join Server</p>
  </div>
  <div class="panel-container">
    <form name="createJS"
          class="createNS"
          #validate="ngForm"
          action="">

      <div class="createNS-row">
        <label class="widget-create-title">Owner
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <div class="live-search">
          <ngx-select [allowClear]="true"
                     #select1
                     [items]="ownerArray"
                     (select)="selectedOwner($event)"
                     (remove)="removedOwner($event)">
          </ngx-select>
        </div>

      </div>

      <div class="createNS-row">
        <label for="name"
               class="widget-create-title">Name
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="name"
               class="widget-create-content form-control"
               [ngClass]="{'nameUsedError': nameExist}"
               [(ngModel)]="joinServerModel.name"
               name="name"
               required
               #nameInput
               maxlength="40"
               #name="ngModel"
               (input)="validateName(joinServerModel.name, nameInput)"
               (keyup)="trimValue($event)"
               autocomplete="off">
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>

        <!--Errors-->
        <div *ngIf="name.invalid && (name.dirty || name.touched)"
             class="alert alert-danger alert-validate">
          <div [hidden]="!name.hasError('required')">Name is required</div>
        </div>
        <div *ngIf="nameExist"
             class="alert alert-danger alert-validate">Name already exist!
        </div>
      </div>

      <div class="createNS-row">
        <div *ngFor="let joinEUI of joinServerModel.joinEUIs; let i = index; trackBy: trackByFn">
          <label *ngIf="i==0"
                 class="widget-create-title">JoinEui
            <i class="fa fa-info-circle info-text"></i>
          </label>
          <label *ngIf="i!=0"
                 class="widget-create-title"></label>
          <input class="widget-create-content add-ids-input"
                 [(ngModel)]="joinServerModel.joinEUIs[i]"
                 (change)="editJoinEUI(i, $event)"
                 name="f{{i}}"
                 id="f{{i}}"
                 #joinEUI="ngModel"
                 (input)="validateId(joinServerModel.joinEUIs[i], i)"
                 autocomplete="off">
          <button class="add-row"
                  (click)="removeJoinEUI(inputJoinEUI.value,i)">-
          </button>

          <!--Error-->
          <div *ngIf="trackingPattern[i]"
               class="alert alert-danger alert-validate">JoinEUI is not valid! It should be in format [prefix]/[prefixLength] where prefix contains 16 hexadecimal characters and prefixLength should be a number between 1 and 64.
          </div>
          <div *ngIf="trackingArr[i]"
               class="alert alert-danger alert-validate">Another network node with same NetID/JoinEUI already exists in the database!
          </div>
          <div *ngIf="trackingArr[i]==false && trackingPattern[i]==false && trackingCheck[i]"
               class="alert alert-danger alert-validate">You already entered this JoinEUI!
          </div>

        </div>
        <label *ngIf="joinServerModel.joinEUIs.length == 0"
               class="widget-create-title">JoinEUI
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <label *ngIf="joinServerModel.joinEUIs.length != 0"
               class="widget-create-title"></label>
        <input #inputJoinEUI
               class="widget-create-content add-ids-input"
               name="joinEUI"
               (input)="validation(inputJoinEUI.value)"
               autocomplete="off">
        <button class="add-row"
                (click)="addJoinEUI(inputJoinEUI.value)">+
        </button>

        <!--Error-->
        <div *ngIf="noValid"
             class="alert alert-danger alert-validate">JoinEUI is not valid! It should be in format [prefix]/[prefixLength] where prefix contains 16 hexadecimal characters and prefixLength should be a number between 1 and 64.
        </div>
        <div *ngIf="joinIdExist"
             class="alert alert-danger alert-validate">Another network node with same NetID/JoinEUI already exists in the database!
        </div>
        <div *ngIf="joinIdExist==false && noValid==false && duplicatesExist"
             class="alert alert-danger alert-validate">You already entered this JoinEUI!
        </div>
      </div>

      <!-- JS URL Field-->
      <div class="createNS-row">
        <label for="url_js"
               class="widget-create-title">JS URL
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <input id="url_js"
               #urlInput
               class="widget-create-content form-control"
               [(ngModel)]="joinServerModel.url_js"
               name="url_js"
               #url_js="ngModel"
               (input)="validateURL(joinServerModel.url_js, urlInput)"
               (change)="validateURL(joinServerModel.url_js, urlInput)"
               autocomplete="off">
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>

        <div *ngIf="errorValidURL"
             class="alert alert-danger alert-validate">URL is required.
        </div>
        <div *ngIf="errorPatternURL"
             class="alert alert-danger alert-validate">URL is invalid.
        </div>
      </div>

      <!-- JS Claim URL Field-->
      <div class="createNS-row">
        <label for="url_claim"
               class="widget-create-title">Claim URL
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <input id="url_claim"
               #urlClaimInput
               class="widget-create-content form-control"
               [(ngModel)]="joinServerModel.url_claim"
               name="url_claim"
               #url_claim="ngModel"
               (input)="validateURL(joinServerModel.url_claim, urlClaimInput)"
               (change)="validateURL(joinServerModel.url_claim, urlClaimInput)"
               autocomplete="off">
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>

        <div *ngIf="errorPatternClaimURL"
             class="alert alert-danger alert-validate">Claim URL is invalid.
        </div>
      </div>

      <!--  Platform field-->
      <div class="createNS-row">
        <label class="widget-create-title">Platform
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <div class="live-search">
          <ngx-select [allowClear]="true"
                     #select2
                     [items]="allPlatforms"
                     (select)="selectedPlatform($event)"
                     (remove)="removedPlatform($event)"
                     [disabled]="disabled">
          </ngx-select>
        </div>
      </div>

      <!--  ProtocolVersion field-->
      <div class="createNS-row">
        <label class="widget-create-title">Protocol Version
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <div class="live-search">
          <ngx-select [items]="protocolVersions"
                     (select)="selectedProtocolVersion($event)">
          </ngx-select>
        </div>
      </div>

      <!--  Http Mode -->
      <div class="createNS-row">
        <label class="widget-create-title">HTTP Mode
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <div class="live-search">
          <ngx-select [items]="httpModes"
                     (select)="selectedHttpMode($event)">
          </ngx-select>
        </div>
      </div>

      <!--Auth Type field-->
      <div class="createNS-row">
        <label class="widget-create-title">HTTP Auth Type
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <div class="live-search">
          <ngx-select [items]="authTypes"
                     (select)="selectedAuthType($event)">
          </ngx-select>
        </div>
      </div>

      <div class="createNS-row" *ngIf="joinServerModel.authType == 'BasicAuth'">
        <label for="authUsername"
               class="widget-create-title">Auth Username
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="authUsername"
               class="widget-create-content form-control"
               [(ngModel)]="joinServerModel.authUsername"
               name="authUsername"
               maxlength="20"
               autocomplete="off">
      </div>

      <div class="createNS-row" *ngIf="joinServerModel.authType == 'BasicAuth'">
        <label for="authPassword"
               class="widget-create-title">Auth Password
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="authPassword"
               class="widget-create-content form-control"
               [(ngModel)]="joinServerModel.authPassword"
               name="authPassword"
               maxlength="20"
               autocomplete="off">
      </div>

      <!-- Security field-->
      <div class="createNS-row">
        <label class="widget-create-title">Transport Security
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <div class="live-search">
          <ngx-select [items]="securityOptions"
                     (select)="selectedSecurity($event)">
          </ngx-select>
        </div>
      </div>


      <div class="btn-area">
        <button (click)="backClicked()"
                class="custom-btn">Cancel
        </button>
        <button type="submit"
                class="custom-btn create-btn form-control"
                [disabled]="disableName || !patternURL || !patternClaimURL || !validURL || !validate.valid || hasError ||
                nameExist || duplicatesExist || noValid || doNotHaveJoinEUI || disableSaveButton ||
                joinIdExist || patternError || !platformExists"
                (click)="addJoinEUI(inputJoinEUI.value);saveJoinServer()">Save
        </button>
      </div>

    </form>
  </div>

</div>
